"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The FullReportStatsFilter model module.
 * @module model/FullReportStatsFilter
 * @version 1.1.3-alpha.1
 */
class FullReportStatsFilter {
  /**
   * Constructs a new <code>FullReportStatsFilter</code>.
   * @alias module:model/FullReportStatsFilter
   */
  constructor() {
    FullReportStatsFilter.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>FullReportStatsFilter</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FullReportStatsFilter} obj Optional instance to populate.
   * @return {module:model/FullReportStatsFilter} The populated <code>FullReportStatsFilter</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new FullReportStatsFilter();
      if (data.hasOwnProperty('customer_id')) {
        obj['customer_id'] = _ApiClient.default.convertToType(data['customer_id'], 'String');
      }
      if (data.hasOwnProperty('subscription_type_id')) {
        obj['subscription_type_id'] = _ApiClient.default.convertToType(data['subscription_type_id'], 'String');
      }
      if (data.hasOwnProperty('category_id')) {
        obj['category_id'] = _ApiClient.default.convertToType(data['category_id'], 'String');
      }
      if (data.hasOwnProperty('industry_id')) {
        obj['industry_id'] = _ApiClient.default.convertToType(data['industry_id'], 'String');
      }
      if (data.hasOwnProperty('media_ids')) {
        obj['media_ids'] = _ApiClient.default.convertToType(data['media_ids'], ['String']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>FullReportStatsFilter</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FullReportStatsFilter</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['customer_id'] && !(typeof data['customer_id'] === 'string' || data['customer_id'] instanceof String)) {
      throw new Error("Expected the field `customer_id` to be a primitive type in the JSON string but got " + data['customer_id']);
    }
    // ensure the json data is a string
    if (data['subscription_type_id'] && !(typeof data['subscription_type_id'] === 'string' || data['subscription_type_id'] instanceof String)) {
      throw new Error("Expected the field `subscription_type_id` to be a primitive type in the JSON string but got " + data['subscription_type_id']);
    }
    // ensure the json data is a string
    if (data['category_id'] && !(typeof data['category_id'] === 'string' || data['category_id'] instanceof String)) {
      throw new Error("Expected the field `category_id` to be a primitive type in the JSON string but got " + data['category_id']);
    }
    // ensure the json data is a string
    if (data['industry_id'] && !(typeof data['industry_id'] === 'string' || data['industry_id'] instanceof String)) {
      throw new Error("Expected the field `industry_id` to be a primitive type in the JSON string but got " + data['industry_id']);
    }
    // ensure the json data is an array
    if (!Array.isArray(data['media_ids'])) {
      throw new Error("Expected the field `media_ids` to be an array in the JSON data but got " + data['media_ids']);
    }
    return true;
  }
}

/**
 * @member {String} customer_id
 */
FullReportStatsFilter.prototype['customer_id'] = undefined;

/**
 * @member {String} subscription_type_id
 */
FullReportStatsFilter.prototype['subscription_type_id'] = undefined;

/**
 * @member {String} category_id
 */
FullReportStatsFilter.prototype['category_id'] = undefined;

/**
 * @member {String} industry_id
 */
FullReportStatsFilter.prototype['industry_id'] = undefined;

/**
 * @member {Array.<String>} media_ids
 */
FullReportStatsFilter.prototype['media_ids'] = undefined;
var _default = exports.default = FullReportStatsFilter;